import { render } from "./CareerManagement.vue?vue&type=template&id=4560faf0&scoped=true"
import script from "./CareerManagement.vue?vue&type=script&lang=js"
export * from "./CareerManagement.vue?vue&type=script&lang=js"

import "./CareerManagement.vue?vue&type=style&index=0&id=4560faf0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4560faf0"]])

export default __exports__